
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top-charts/[id]",
      function () {
        return require("private-next-pages/top-charts/[id].js");
      }
    ]);
  